exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".claim-line-item-panel{background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.12),0 1px 3px rgba(0,0,0,.24);margin-bottom:20px;padding:18px}.claim-line-item-panel header{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:1.8rem;margin-bottom:10px}.claim-line-item-panel .claim-line-item-header{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/claim/spa/components/claim-line-item-panel/index.scss
// module id = 5072
// module chunks = 0